import React, { Component, PropTypes } from 'react';
import cx from 'classnames';
import classes from './dropdownItem.scss';
import { itemHeight } from '../constants';
import { Actions } from '../reducer';

class DropdownItem extends Component {
  state = {
    numMoves: 0,
  };

  handleMouseMove = () => {
    const numMoves = this.state.numMoves + 1;
    if (numMoves === 2) {
      this.props.dispatch(Actions.selectItemByIndex(this.props.index));
      this.setState({ numMoves: 0 });
    } else if (numMoves < 2 && !this.props.selected) {
      this.setState({ numMoves });
    }
  };

  handleClick = () => {
    const { handleClickItem, item } = this.props;
    handleClickItem(item.name, item);
  };

  render() {
    const { item, selected } = this.props;
    const itemClasses = cx({
      [classes.item]: true,
      [classes.selected]: !!selected,
    });
    const itemStyle = {
      height: `${itemHeight}px`,
    };
    const itemProps = {
      className: itemClasses,
      style: itemStyle,
      onClick: this.handleClick,
      onMouseEnter: this.handleMouseEnter,
      onMouseMove: this.handleMouseMove,
    };

    const discountClassName = cx({
      [classes.discount]: true,
      [classes.soldOut]: item.info === 'Out of stock',
    });

    return (
      <li { ...itemProps } >
        <div>
          <img src={ item.image_url } />
            <div className={classes.itemInfo} >
              <div className={classes.name} >{ item.name }</div>
              <div className={discountClassName} >{ item.info }</div>
            </div>
        </div>
      </li>
    );
  }
}

DropdownItem.propTypes = {
  item: PropTypes.object.isRequired,
  index: PropTypes.number.isRequired,
  selected: PropTypes.bool,
  dispatch: PropTypes.func.isRequired,
  handleClickItem: PropTypes.func.isRequired,
};

export default DropdownItem;



/** WEBPACK FOOTER **
 ** ./shared-components/SearchBar/components/DropdownItem.js
 **/